import { requestBuilder } from '../../http/RequestBuilder';

export interface ACHTransferExpectedArrivalResponse {
    expectedArrivalDate: string;
}

/**
 * Preview settlement timing for a one-time depository transfer (ACH / external legs).
 */
const useGetACHTransferExpectedArrival =
    requestBuilder.query<ACHTransferExpectedArrivalResponse>({
        endpoint: '/api/depository-transfer/ach-expected-arrival',
        queryKey: '/api/depository-transfer/ach-expected-arrival',
    });

export default useGetACHTransferExpectedArrival;
